import { Profile, User, UserSocial } from "./types";

export const isConnected = (
  user: User | null,
  service: string,
  integrationIds: string[] = [],
  profile: Profile,
  integrations: Record<string, { id: string }[]> = {},
) => {
  if (
    user &&
    profile &&
    profile.team &&
    user.joinedTeams.some(teamMember => teamMember.teamId === profile.team.id)
  ) {
    return true;
  }

  if (!integrations?.[service]?.length) {
    return false;
  }

  return (
    !integrationIds.length ||
    integrationIds.every(id =>
      integrations[service].some(item => item.id === id),
    )
  );
};

export const getConnectedIntegrations = (
  integrationIds: string[] = [],
  integrations: UserSocial[] = [],
) => (integrationIds.length ? integrationIds : [integrations?.[0]?.id]);

export const googleScopeLabels: Record<string, string> = {
  basic: "Basic profile",
  calendar: "Google Calendar",
  gmail: "Gmail",
  directory: "Workspace directory",
};

export const describeGoogleScopes = (scopes: string[] = []) =>
  scopes.map(scope => googleScopeLabels[scope] ?? scope).join(" and ");

export const integrationConnectUrl = (
  service: string,
  {
    accessToken,
    scopes = [],
  }: { accessToken?: string | null; scopes?: string[] } = {},
) => {
  const params = new URLSearchParams();
  if (accessToken) {
    params.set("token", accessToken);
  }
  if (scopes.length) {
    params.set("scopes", scopes.join(","));
  }
  const query = params.toString();

  return `${import.meta.env.VITE_BASE_URL}/auth/${service}/connect${query ? `?${query}` : ""}`;
};
